import styled from 'styled-components';

import mediaQueries from 'constants/mediaQueries';
import { imageBackgroundFallback, imageBoxShadow } from 'constants/colors';

type StyleApplier = (isMobile: boolean, size?: string) => string;

type StyleChooser = (props: { size?: string }) => string;

const marginCardChooser: StyleChooser = ({ size }) => {
  switch (size) {
    case 'xlg':
    case 'lg':
      return '12px';
    case 'md':
      return '12px';
    case 'sm':
    default:
      return '8px';
  }
};

const marginHeadingPlainText: StyleApplier = (isMobile, size) => {
  switch (size) {
    case 'xlg':
    case 'lg':
    case 'md':
      return '24px';
    case 'sm':
    default:
      return isMobile ? '16px' : '24px';
  }
};

const marginHeadingWithImage: StyleApplier = (isMobile, size) => {
  switch (size) {
    case 'xlg':
    case 'lg':
      return '16px';
    case 'md':
      return isMobile ? '8px' : '16px';
    case 'sm':
    default:
      return '8px';
  }
};

const marginHeadingChooser = (isMobile: boolean) => ({
  size,
  isPlainText,
}: {
  size: string;
  isPlainText: boolean;
}) =>
  isPlainText
    ? marginHeadingPlainText(isMobile, size)
    : marginHeadingWithImage(isMobile, size);

const marginImageChooser = (isMobile: boolean) => ({
  size,
}: {
  size?: string;
}) => {
  switch (size) {
    case 'xlg':
    case 'lg':
      return isMobile ? '24px' : '32px';
    case 'md':
      return isMobile ? '16px' : '24px';
    case 'sm':
    default:
      return '16px';
  }
};

const imageHeightChooser: StyleChooser = ({ size }) => {
  switch (size) {
    case 'xlg':
    case 'lg':
      return '264px';
    case 'md':
      return '167px';
    case 'sm':
    default:
      return '126px';
  }
};

const maxWidthChooser: StyleChooser = ({ size }) => {
  switch (size) {
    case 'xlg':
      return '100%';
    case 'lg':
      return '432px';
    case 'md':
      return '273px';
    case 'sm':
    default:
      return '204px';
  }
};

export const FlexibleLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 32px 0;

  ${mediaQueries.mobileOnly} {
    margin: 0;
    flex-direction: column;
  }
`;

export const CardWrapper = styled.div<{ size?: string }>`
  flex: 1;
  max-width: ${maxWidthChooser};
  margin: 0px ${marginCardChooser};

  ${mediaQueries.mobileOnly} {
    max-width: 100%;
    margin: 28px 0;
  }
`;

export const CardImage = styled.div<{ url?: string; size?: string }>`
  width: 100%;
  height: ${imageHeightChooser};
  margin-bottom: ${marginImageChooser(false)};
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  ${({ url }) =>
    url
      ? `background-image: url(${url});`
      : `background-color: ${imageBackgroundFallback};`}
  ${imageBoxShadow}

  ${mediaQueries.mobileOnly} {
    height: 210px;
    margin-bottom: ${marginImageChooser(true)};
  }
`;

export const HeadingWrapper = styled.div`
  margin-bottom: ${marginHeadingChooser(false)};

  ${mediaQueries.mobileOnly} {
    margin-bottom: ${marginHeadingChooser(true)};
  }
`;

export const SubHeadingWrapper = styled.div``;
